import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonLoaderComponent } from 'shared/components/skeleton-loader/skeleton-loader.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SkeletonLoaderComponent
  ],
  exports: [
    SkeletonLoaderComponent
  ]
})
export class SkeletonLoaderModule {}
